export const CSS_UNITS = 96.0 / 72.0;
export const DEFAULT_SCALE_VALUE = 'auto';
export const DEFAULT_SCALE = 1.0;
export const UNKNOWN_SCALE = 0;
export const MAX_AUTO_SCALE = 1.25;
export const SCROLLBAR_PADDING = 40;
export const VERTICAL_PADDING = 5;
export const DEFAULT_CACHE_SIZE = 15;
